export const API_EXTERNAL_ENDPOINT = 'search/seo/facet/:facetSlug'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/search/seo/facet'
